import { Component, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-message-container',
  templateUrl: './message-container.component.html',
  styleUrls: ['./message-container.component.scss'],
})

/**
 * 単項目エラーメッセージ
 */
export class MessageContainerComponent implements OnInit {
  /** コントロール */
  @Input() control: FormControl;

  constructor() {}

  ngOnInit(): void {}

  public hasError(): boolean {
    if (!this.control) {
      return;
    }
    return this.control.errors && this.control.dirty;
  }

  public mapToErrorMessage(): string {
    return this.control.errors.message;
  }
}
